import script from "./lysettings.vue?vue&type=script&setup=true&lang=js"
export * from "./lysettings.vue?vue&type=script&setup=true&lang=js"

import "./lysettings.vue?vue&type=style&index=0&id=e276ff0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e276ff0c"]])

export default __exports__